module.exports = {
  path: '500',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/500'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/500/index.js